import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-20 md:py-28 px-4 bg-warm-gray watermark-bg" data-id="element-196">
      <div className="max-w-2xl mx-auto" data-id="element-197">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-198">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-199">
            You Know This Feeling.
          </h2>

          <div className="space-y-6 text-lg text-charcoal/90 leading-relaxed" data-id="element-200">
            <p data-id="element-201">It's 11 PM.</p>

            <p data-id="element-202">The house is quiet. Everyone else is asleep.</p>

            <p data-id="element-203">
              But your mind is running at full speed — replaying the same
              relationship decision you've been circling for weeks. Maybe
              months.
            </p>

            <div className="pl-6 border-l-2 border-gold/40 py-2 my-8 space-y-3 font-serif italic text-xl text-charcoal" data-id="element-204">
              <p data-id="element-205">Do I stay or do I go?</p>
              <p data-id="element-206">Is this peace I feel — or am I just scared of being alone?</p>
              <p data-id="element-207">
                Is this God's direction — or is it my own attachment talking?
              </p>
            </div>

            <p data-id="element-208">You've done everything right.</p>

            <p data-id="element-209">
              You prayed. You fasted. You filled three journals. You called your
              best friend, your pastor, your sister — and each of them said
              something different.
            </p>

            <p data-id="element-210">And you're still stuck.</p>

            <p className="pt-6 font-semibold" data-id="element-211">Here's what no one tells you:</p>

            <div className="bg-cream p-6 md:p-8 rounded-xl shadow-sm border border-gold/10 my-8" data-id="element-212">
              <p className="text-xl font-bold text-charcoal text-center" data-id="element-213">
                The problem isn't that you're not spiritual enough.
                <br className="hidden md:block" data-id="element-214" />
                The problem is that you don't have a system.
              </p>
            </div>

            <p className="text-center font-serif italic text-xl" data-id="element-215">
              Inspiration without a framework is just beautiful confusion.
            </p>

            <p className="text-center pt-4" data-id="element-216">
              What you need isn't another devotional. Another prayer. Another
              "just trust God."
            </p>

            <p className="text-center text-2xl font-bold text-gold pt-4" data-id="element-217">
              What you need is a filter.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}